import React, { forwardRef } from 'react'
import { View } from 'react-native'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type IconButtonProps = Omit<BaseButtonProps, 'rightIcon' | 'loading' | 'buttonType' | 'selected'>

export const IconButton = forwardRef<React.ElementRef<typeof View>, IconButtonProps>((props, ref) => {
  return <BaseButton {...props} ref={ref} buttonType={ButtonType.ICON} />
})

export default IconButton
